import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn, openingEffect, scrollHidden } from '@/styles/common';

export const Wrapper = styled.div`
  ${flexColumn};
  width: 100%;
  transition: width 0.3s ease;
  position: relative;
`;

export const Dropdown = styled.div<{
  $isOpen: boolean;
  $isModal: boolean;
  $hasValue: boolean;
}>`
  width: 100%;
  background: var(--bg-main);
  border-radius: 28px;
  z-index: 9;
  position: fixed;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    & > * {
      padding-inline: 30px;
    }
    padding-bottom: 20px;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    & > * {
      padding-inline: 16px;
    }
    padding-bottom: 16px;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    & > * {
      padding-inline: 30px;
    }
    padding-block: 25px;
  }

  ${({ $isModal, $isOpen }) =>
    $isModal
      ? css`
          width: 100vw;
          height: 100%;
          max-height: 100dvh;
          overflow-y: auto;
          overflow-x: hidden;
          ${scrollHidden};
          top: 0;
          left: 0;
          transform: ${$isOpen
            ? 'translate(0)'
            : 'translateY(120%)'} !important;
          border-radius: 0;
          transition: transform 0.3s ease;
        `
      : openingEffect(-10, { opacity: true, visibility: true })}

  ${({ $isModal }) => !$isModal && flexColumn}
`;

export const DropdownSectionTitle = styled(Typography).attrs({
  variant: 'title3'
})`
  color: var(--textAndLabels-tertiary);
`;

export const CategoriesSectionWrapper = styled.div`
  ${flexColumn}
  gap: 20px;
`;

export const SuggestionsSectionWrapper = styled.div`
  ${flexColumn}
  gap: 12px;
`;

export const DropdownItemsWrapper = styled.div`
  ${flexColumn}
  height: 100%;
`;

export const DropdownItem = styled.button`
  width: fit-content;
  padding: 12px 0;
  background: none;
  border: none;
  text-align: left;
  color: var(--textAndLabels-main);
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DropdownHeader = styled.div`
  top: 0;
  position: sticky;
  ${flexColumn}
  gap: 15px;
  z-index: 10;
  background-color: var(--bg-main);

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-top: 10px;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding-top: 20px;
  }

  padding-bottom: 20px;
`;

export const DropdownContent = styled.div`
  gap: 20px;

  @media (min-width: ${BREAKPOINTS.laptop}) {
    overflow-y: auto;
  }
`;

export const DropdownHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;
